<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Table-->
<div>
	<!--Menu Bar-->
	<div class="lock-to-top" style="background-color: #f3f3f4">
		<!--Balance-->
		<div class="CurrentBalanceBackgroud">
			<label>{{ BalanceText }}</label>

			<label>{{ CurrentBalanceDesc }}</label>
		</div>

		<!--Menu-->
		<div class="CurrentBalanceBackgroud">
			<div class="MenuItems">
				<label>Display:</label>
				<select class="form-control" name="NotPaidOnly" [(ngModel)]="NotPaidOnly" (ngModelChange)="onNotPaidOnlyChange($event)">
					<option *ngFor="let r of lstNotPaidOnly" [ngValue]="r.ID">
						{{ r.Desc }}
					</option>
				</select>

				<label>Order By:</label>
				<select class="form-control" name="OrderAsc" [(ngModel)]="OrderAsc" (ngModelChange)="onOrderAscChange($event)">
					<option *ngFor="let r of lstOrderAsc" [ngValue]="r.ID">
						{{ r.Desc }}
					</option>
				</select>
			</div>
		</div>

		<!--Buttons-->
		<div class="button-body flex">
			<button
				[disabled]="SelectedPerson == undefined || loading == true || isProcessing == true"
				class="btn btn-primary"
				style="margin-left: 0px"
				(click)="onRefresh()"
			>
				Refresh
			</button>

			<!--INSERT CUSTOM BUTTONS HERE-->
			<button
				[disabled]="SelectedPerson == undefined || loading == true || isProcessing == true"
				class="btn btn-primary"
				style="margin-left: 5px"
				(click)="onAddFine()"
			>
				Add Fine
			</button>
			<button
				[disabled]="SelectedPerson == undefined || loading == true || isProcessing == true"
				class="btn btn-primary"
				style="margin-left: 5px"
				(click)="onPayFine()"
			>
				Pay/Waive
			</button>
			<button
				[disabled]="SelectedPerson == undefined || loading == true || isProcessing == true"
				class="btn btn-primary"
				style="margin-left: 5px"
				(click)="onRefund()"
			>
				Refund
			</button>
			<button
				[disabled]="SelectedPerson == undefined || loading == true || isProcessing == true"
				class="btn btn-primary"
				style="margin-left: 5px"
				(click)="onAdjust()"
			>
				Adjust
			</button>
			<button
				[disabled]="SelectedPerson == undefined || loading == true || isProcessing == true"
				class="btn btn-primary"
				style="margin-left: 5px"
				(click)="onViewDetails()"
			>
				View Details
			</button>
			<button
				[disabled]="SelectedPerson == undefined || loading == true || isProcessing == true"
				class="btn btn-primary"
				style="margin-left: 5px"
				(click)="onPrintHistory()"
			>
				Print History
			</button>
		</div>
	</div>

	<!--Table-->
	<div class="table-main-body">
		<p-table
			#mydt
			[value]="lstFine"
			[loading]="loading"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="single"
			[(selection)]="SelectedFine"
			dataKey="FineID"
			(onFilter)="onHandleFilter($event)"
			(onSort)="onHandleSort($event)"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<!--INSERT CUSTOM FILTERS HERE-->

					<!--FineDateDesc-->
					<th>
						<!-- <p-columnFilter type="text" field="FineDateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
					</th>

					<!--FineTypeDesc-->
					<th>
						<p-columnFilter field="FineTypeDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterFineTypeDesc
									[ngModel]="value"
									[options]="lstFineTypeDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--Amount-->
					<th>
						<!-- <p-columnFilter type="text" field="Amount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
					</th>

					<!--Waived-->
					<th>
						<!-- <p-columnFilter type="text" field="Waived" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
					</th>

					<!--Paid-->
					<th>
						<!-- <p-columnFilter type="text" field="Paid" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
					</th>

					<!--Balance-->
					<th>
						<!-- <p-columnFilter type="text" field="Balance" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
					</th>

					<!--FineComment-->
					<th>
						<p-columnFilter type="text" field="FineComment" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--PartOfGroupAction-->
					<th>
						<p-columnFilter field="PartOfGroupAction" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterPartOfGroupAction
									[ngModel]="value"
									[options]="lstPartOfGroupAction"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--GroupName-->
					<th>
						<p-columnFilter type="text" field="GroupName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="FineDate">Date/Time<p-sortIcon field="FineDate"></p-sortIcon></th>
					<th pSortableColumn="FineTypeDesc">Type<p-sortIcon field="FineTypeDesc"></p-sortIcon></th>
					<th pSortableColumn="Amount">Charged<p-sortIcon field="Amount"></p-sortIcon></th>
					<th pSortableColumn="Waived">Adjusted<p-sortIcon field="Waived"></p-sortIcon></th>
					<th pSortableColumn="Paid">Paid<p-sortIcon field="Paid"></p-sortIcon></th>
					<th pSortableColumn="Balance">Balance<p-sortIcon field="Balance"></p-sortIcon></th>
					<th pSortableColumn="FineComment">Comments<p-sortIcon field="FineComment"></p-sortIcon></th>
					<th pSortableColumn="PartOfGroupAction">Part of Group Action<p-sortIcon field="PartOfGroupAction"></p-sortIcon></th>
					<th pSortableColumn="GroupName">Group Name<p-sortIcon field="GroupName"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-Fine>
				<tr [pSelectableRow]="Fine" (dblclick)="onRowDblClick(Fine)">
					<td *ngFor="let col of cols" style="font-weight: bold">
						{{ Fine[col.field] }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>

	<!--Error Message-->
	<div class="TopMargin">
		<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
			{{ errorMessage }}
		</div>
	</div>

	<div class="TopMargin">
		<div name="isProcessing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
	</div>
</div>
